import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import { can } from '../lib/permissions'

type PermissionGateProps = {
  permission: string
  children: ReactNode
}

export function PermissionGate({ permission, children }: PermissionGateProps) {
  const { me } = useAuth()

  if (!can(me?.permissions ?? [], permission)) {
    return <Navigate to="/forbidden" replace />
  }

  return children
}
